<div class="sophia-app">
  <!-- <div class="test-mode-banner">
    <p class="blinking-text">Test Mode</p>
  </div> -->
  <router-outlet></router-outlet>
</div>